import {
  Injectable
} from '@angular/core';
import {
  HttpClient
} from '@angular/common/http';
import {
  API
} from '../config/api';
import {
  PrintRequest,
  CRUDPrint,
  TableToPrintModel
} from './print.DTO';
import {
  BoSpinnerService
} from '../../shared';
import {
  tap
} from 'rxjs/operators';
import {
  TypeRate
} from '../../../@shared/constants';

@Injectable()
export class PrintService {
  constructor(
    private _http: HttpClient,
    private _spinner: BoSpinnerService
  ) {}

  public print(model: CRUDPrint, disableSpinner ? : boolean, type ? : string) {
    if (!disableSpinner) {
      this._spinner.show();
    }
    let printModelRequest: PrintRequest;
    switch (type) {
      case TypeRate.SAME_DAY_PENCE_PER_MILE_ONLY:
        printModelRequest = this.sameDayPencePerMileOnlyModel(model);
        break;
      case TypeRate.SAME_DAY_MIN_DISTANCE_PENCE_PER_MILE:
        printModelRequest = this.sameDayMinDistancePencePerMileModel(model);
        break;
      case TypeRate.CONSIGNMENT_PLUS_KG:
        printModelRequest = this.consignmentPlusKgModel(model);
        break;
      case TypeRate.PALLET:
        printModelRequest = this.palletModel(model);
        break;
      case TypeRate.PACKAGE:
        printModelRequest = this.packageModel(model);
        break;
      case TypeRate.PACKAGE_SURCHARGE:
        printModelRequest = this.packageSurchargeModel(model);
        break;
      case TypeRate.PALLET_SURCHARGE:
        printModelRequest = this.palletSurchargeModel(model);
        break;
      default:
        printModelRequest = this.sameDayPencePerMileOnlyModel(model);
        break;
    }
    return this._http.post(`${API.PRINT.PRINT_PDF}`, printModelRequest, {
      responseType: 'blob'
    }).pipe(tap(() => this._spinner.hide()));
  }

  private sameDayPencePerMileOnlyModel(model: CRUDPrint) {
    let tableToPrintModel: TableToPrintModel = {
      tableHeader: [],
      tableBody: []
    };
    let modelPrintRequest: PrintRequest = {
      name: model.name,
      additionalInfor: model.additionalInfor,
      tableToPrint: [
        tableToPrintModel
      ]
    };
    tableToPrintModel.tableHeader = [
      [{
          rowSpan: 0,
          colSpan: 0,
          value: "Vehicle Type"
        },
        {
          rowSpan: 0,
          colSpan: 0,
          value: "Pence Per Mile"
        }
      ]
    ];
    let arrayRowBody = [];
    for (let i = 0; i < model.data.length; i++) {
      arrayRowBody.push(model.data[i].vehicleType, '&#163;' + model.data[i].pencePerMile)
      tableToPrintModel.tableBody.push(arrayRowBody);
      arrayRowBody = [];
    }
    return modelPrintRequest;
  }

  private sameDayMinDistancePencePerMileModel(model: CRUDPrint) {
    let tableToPrintModel: TableToPrintModel = {
      tableHeader: [],
      tableBody: []
    };
    let modelPrintRequest: PrintRequest = {
      name: model.name,
      additionalInfor: model.additionalInfor,
      tableToPrint: [
        tableToPrintModel
      ]
    };
    tableToPrintModel.tableHeader = [
      [{
          rowSpan: 0,
          colSpan: 0,
          value: "Vehicle Type"
        },
        {
          rowSpan: 0,
          colSpan: 0,
          value: "1st X Miles"
        },
        {
          rowSpan: 0,
          colSpan: 0,
          value: "Flat Rate (for 1st X Miles)"
        },
        {
          rowSpan: 0,
          colSpan: 0,
          value: "Pence per Additional Mile"
        }
      ]
    ];
    let arrayRowBody = [];
    for (let i = 0; i < model.data.length; i++) {
      arrayRowBody.push(model.data[i].vehicleType, model.data[i].firstXMiles + 'Miles', '&#163;' + model.data[i].firstXMiles,
        '&#163;' + model.data[i].firstXMiles)
      tableToPrintModel.tableBody.push(arrayRowBody);
      arrayRowBody = [];
    }
    return modelPrintRequest;
  }

  private consignmentPlusKgModel(model: CRUDPrint) {
    let tableToPrintModel: TableToPrintModel = {
      tableHeader: [],
      tableBody: []
    };
    let modelPrintRequest: PrintRequest = {
      name: model.name,
      additionalInfor: model.additionalInfor,
      tableToPrint: [
        tableToPrintModel
      ]
    };
    tableToPrintModel.tableHeader = [
      [{
          rowSpan: 2,
          colSpan: 0,
          value: "Zone"
        },
        {
          rowSpan: 2,
          colSpan: 0,
          value: "Service"
        },
        {
          rowSpan: 0,
          colSpan: 3,
          value: "Base Rate"
        },
        {
          rowSpan: 0,
          colSpan: 4,
          value: "Add per " + model.packetRate.pencePerUnit + 'kg'
        },
      ],
      [{
          rowSpan: 0,
          colSpan: 0,
          value: "1-" + model.packetRate.baseRate1 + 'kg'
        },
        {
          rowSpan: 0,
          colSpan: 0,
          value: model.packetRate.baseRate2 + "-199kg"
        },
        {
          rowSpan: 0,
          colSpan: 0,
          value: model.packetRate.baseRate3 + "+kg"
        },
        {
          rowSpan: 0,
          colSpa: 0,
          value: model.packetRate.minAddPer1 + '-' + model.packetRate.baseRate2 + 'kg add per ' + model.packetRate.pencePerUnit + 'kg'
        },
        {
          rowSpan: 0,
          colSpan: 0,
          value: model.packetRate.minAddPer2 + '-' + model.packetRate.baseRate3 + 'kg add per ' + model.packetRate.pencePerUnit + 'kg'
        },
        {
          rowSpan: 0,
          colSpan: 0,
          value: model.packetRate.minAddPer3 + '-' + model.packetRate.addPerKg + 'kg add per ' + model.packetRate.pencePerUnit + 'kg'
        },
        {
          rowSpan: 0,
          colSpan: 0,
          value: model.packetRate.maxAddPerKg + 'kg add per ' + model.packetRate.pencePerUnit + 'kg'
        }
      ]
    ];
    let arrayRowBody = [];
    for (let i = 0; i < model.data.length; i++) {
      arrayRowBody.push(model.data[i].zone, model.data[i].service, '&#163;' + model.data[i].baseRate1Cost,
      '&#163;' + model.data[i].baseRate2Cost, '&#163;' + model.data[i].baseRate3Cost, '&#163;' + model.data[i].addPerKg1,
      '&#163;' + model.data[i].addPerKg2, '&#163;' + model.data[i].addPerKg3, '&#163;' + model.data[i].addPerKg4)
      tableToPrintModel.tableBody.push(arrayRowBody);
      arrayRowBody = [];
    }
    return modelPrintRequest;
  }

  private packageModel(model: CRUDPrint) {
    let tableToPrintModel: TableToPrintModel = {
      tableHeader: [],
      tableBody: []
    };
    let modelPrintRequest: PrintRequest = {
      name: model.name,
      additionalInfor: model.additionalInfor,
      tableToPrint: [
        tableToPrintModel
      ]
    };
    tableToPrintModel.tableHeader = [
      [{
          rowSpan: 0,
          colSpan: 0,
          value: "Service Level"
        },
        {
          rowSpan: 0,
          colSpan: 0,
          value: "First Box Price " + model.packetRate.firstBoxPricePercent + '%'
        },
        {
          rowSpan: 0,
          colSpan: 0,
          value: "Subsequent Boxes " + model.packetRate.subsequentBoxesPercent + '%'
        },
        {
          rowSpan: 0,
          colSpan: 0,
          value: "To Zone 2"
        },
        {
          rowSpan: 0,
          colSpan: 0,
          value: "Zone 2 Minnimum " + model.packetRate.zone2MinimumPercent + '%'
        },
        {
          rowSpan: 0,
          colSpan: 0,
          value: "To Zone 3"
        },
        {
          rowSpan: 0,
          colSpan: 0,
          value: "Zone 3 Minnimum " + model.packetRate.zone3MinimumPercent + '%'
        }
      ]
    ];
    let arrayRowBody = [];
    for (let i = 0; i < model.data.length; i++) {
      arrayRowBody.push(model.data[i].serviceLevel, '&#163;' + model.data[i].firstBoxPrice, '&#163;' + model.data[i].subsequentBoxes,
        model.data[i].toZone2 + '%', '&#163;' + model.data[i].zone2Minimum, model.data[i].toZone3 + '%', '&#163;' + model.data[i].zone3Minimum)
      tableToPrintModel.tableBody.push(arrayRowBody);
      arrayRowBody = [];
    }
    return modelPrintRequest;
  }

  private packageSurchargeModel(model: CRUDPrint) {
    let tableToPrintModel: TableToPrintModel = {
      tableHeader: [],
      tableBody: []
    };
    let modelPrintRequest: PrintRequest = {
      name: model.name,
      additionalInfor: model.additionalInfor,
      tableToPrint: [
        tableToPrintModel
      ]
    };
    tableToPrintModel.tableHeader = [
      [{
          rowSpan: 0,
          colSpan: 0,
          value: "Name"
        },
        {
          rowSpan: 0,
          colSpan: 0,
          value: "Sellling Price"
        }
      ]
    ];
    let arrayRowBody = [];
    for (let i = 0; i < model.data.length; i++) {
      arrayRowBody.push(model.data[i].name, '&#163;' + model.data[i].sellingPrice)
      tableToPrintModel.tableBody.push(arrayRowBody);
      arrayRowBody = [];
    }
    return modelPrintRequest;
  }

  private palletSurchargeModel(model: CRUDPrint) {
    let tableToPrintModel: TableToPrintModel = {
      tableHeader: [],
      tableBody: []
    };
    let modelPrintRequest: PrintRequest = {
      name: model.name,
      additionalInfor: model.additionalInfor,
      tableToPrint: [
        tableToPrintModel
      ]
    };
    tableToPrintModel.tableHeader = [
      [{
          rowSpan: 0,
          colSpan: 0,
          value: "Option"
        },
        {
          rowSpan: 0,
          colSpan: 0,
          value: "Base Price"
        }
      ]
    ];
    let arrayRowBody = [];
    for (let i = 0; i < model.data.length; i++) {
      arrayRowBody.push(model.data[i].option, '&#163;' + model.data[i].basePrice)
      tableToPrintModel.tableBody.push(arrayRowBody);
      arrayRowBody = [];
    }
    return modelPrintRequest;
  }

  private palletModel(model: CRUDPrint) {
    let tableToPrintModel: TableToPrintModel = {
      tableHeader: [],
      tableBody: []
    };
    let tableToPrintModel1: TableToPrintModel = {
      tableHeader: [],
      tableBody: []
    };
    let modelPrintRequest: PrintRequest = {
      name: model.name,
      additionalInfor: model.additionalInfor,
      tableToPrint: [
        tableToPrintModel,
        tableToPrintModel1
      ]
    };
    tableToPrintModel.tableHeader = [
      [{
        rowSpan: 0,
        colSpan: 4,
        value: "Next Day Service"
      }],
      [{
          rowSpan: 0,
          colSpan: 0,
          value: "Zone"
        },
        {
          rowSpan: 0,
          colSpan: 0,
          value: "Qtr Pallet"
        },
        {
          rowSpan: 0,
          colSpan: 0,
          value: "Half Pallet"
        },
        {
          rowSpan: 0,
          colSpan: 0,
          value: "Full Pallet"
        }
      ]
    ];
    tableToPrintModel1.tableHeader = [
      [{
        rowSpan: 0,
        colSpan: 4,
        value: "Economy Service"
      }],
      [{
          rowSpan: 0,
          colSpan: 0,
          value: "Zone"
        },
        {
          rowSpan: 0,
          colSpan: 0,
          value: "Qtr Pallet"
        },
        {
          rowSpan: 0,
          colSpan: 0,
          value: "Half Pallet"
        },
        {
          rowSpan: 0,
          colSpan: 0,
          value: "Full Pallet"
        }
      ]
    ];
    let arrayRowBody = [];
    for (let i = 0; i < model.data.length; i++) {
      arrayRowBody.push(model.data[i].zone, model.data[i].qtrPallet, model.data[i].halfPallet,
        model.data[i].fullPallet)
      tableToPrintModel.tableBody.push(arrayRowBody);
      arrayRowBody = [];
    }
    let arrayRowBody1 = [];
    for (let i = 0; i < model.data1.length; i++) {
      arrayRowBody1.push(model.data1[i].zone, model.data1[i].qtrPallet, model.data1[i].halfPallet,
        model.data1[i].fullPallet)
      tableToPrintModel1.tableBody.push(arrayRowBody1);
      arrayRowBody1 = [];
    }
    return modelPrintRequest;
  }
}
